export default __webpack_public_path__ + "static/avatar@3x-c7f3646e1a90fe437303cdeb9c39834a.png";